/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, Card, Stack, FormControlLabel, Switch, Skeleton } from '@mui/material';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import axios, { getErrorMessage } from 'utils/axios';
import { FormProvider, RHFTextField, RHFSelect } from 'components/hook-form';
import { LoadingButton } from '@mui/lab';
import CRUD from 'utils/Crud';
import { fData } from 'utils/formatNumber';
import useIsMountedRef from 'hooks/useIsMountedRef';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid whitesmoke',
    boxShadow: 24,
    p: 4,
};


const NewUserSchema = Yup.object().shape({
    coin_id: Yup.string().required('Field is required'),
    hint: Yup.string().required('Field is required'),
    staff_id: Yup.string().required('Field is required'),
    wallet_address: Yup.string().required('Field is required'),
    password: Yup.string().required('Field is required'),
});

AddPaymentWalletAdressModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleComplete: PropTypes.func,
    data: PropTypes.object
}

export default function AddPaymentWalletAdressModal({ open, handleClose,handleComplete, data }) {

    const { enqueueSnackbar } = useSnackbar();
    const isMountedRef = useIsMountedRef();
    const [state,setState] = useState({});
    const [stafState,setStafState] = useState({loading:true,loadComplete:false,error:null, list:[]});
    const [dataList,setDataList] = useState([]);


    const getInitData = useCallback(async () => {
    
        setState({...state,loading:true,loadComplete:false,error:null})
    
        try {
          const response = await axios.get(CRUD.cryptoAssets);
    
          if (isMountedRef.current) {
            setDataList(response.data);
          }
          setState({...state,loading:false,loadComplete:true,error:null})
        } catch (error) {
          // console.error(error);
          setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
        }
      }, [isMountedRef]);

      const getStaffs = useCallback(async () => {
    
        setStafState({...stafState,loading:true,loadComplete:false,error:null})
    
        try {
          const response = await axios.get(CRUD.admin.list);
    
          if (isMountedRef.current) {
            setStafState({...stafState,loading:false,loadComplete:true,error:null,list:response.data});
            }
        } catch (error) {
          // console.error(error);
          setStafState({...stafState,loading:false,loadComplete:false,error: getErrorMessage(error)})
        }
      }, [isMountedRef]);


    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues:{
            // start_amount: range?.start_amount || 0,
            // end_amount: range?.end_amount || 0,
            // symbol: data?.symbol || '',
            // rate: range?.rate || '',
            password: '',
            coin_id: '',
            wallet_address: '',
            staff_id: '',
            hint:''
        },
    });

    useEffect(() => {
        getInitData();
        getStaffs();
      }, [getInitData, getStaffs]);

    const {
        reset,
        watch,
        control,
        setValue,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const values = watch();

    const onSubmit = async () => {
        try {
            await axios.post(`${CRUD.paymentWalletAddress}`,values);
            
            reset();
            enqueueSnackbar('Create success!');
            handleComplete();
        } catch (error) {

        //   console.error(error);
            enqueueSnackbar(getErrorMessage(error), {color:"error"});
        }
    };


    return <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        hideBackdrop={false}
    >
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2"  position="center" >
              Add Payment Address
            </Typography>

            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                <Card sx={{ p: 3, mt:4 }}>

                    <Box  >
                        {state.loading && (
                            <Skeleton variant="rectangular" width="100%" height={48} />
                        )}
                        {state.loadComplete && (
                            <RHFSelect name="coin_id" label="Crypto" placeholder="Select option" required >
                                <option value="" />
                                {dataList.map((option) => (
                                <option key={option.coin_id} value={option.coin_id}>
                                    {option.name} ({option.coin_id})
                                </option>
                                ))}
                            
                            </RHFSelect>
                            )}

                        {stafState.loading && (
                            <Skeleton variant="rectangular" width="100%" height={48} sx={{mt:2}} />
                        )}
                        {stafState.loadComplete && (
                            <RHFSelect name="staff_id" label="Wallet owner " placeholder="Select option" required sx={{mt:2}} >
                                <option value="" />
                                {stafState.list.filter((el,i)=> el.status === "active").map((option) => (
                                <option key={option.staff_id} value={option.staff_id}>
                                    {option.first_name} {option.last_name} ({option.role} - {option.status})
                                </option>
                                ))}
                            
                            </RHFSelect>
                            )}

                        
                        <RHFTextField name="wallet_address" label="Wallet address" sx={{mt:3}} />  
                        {/* <RHFTextField name="network" label="Network (Blockchain only)" sx={{mt:3}} />   */}
                        <RHFTextField name="hint" label="Instruction (e.g blockchain network)" sx={{mt:3}} />  

                        <p style={{marginTop:30}}>Confirm password</p>
                        <RHFTextField name="password" label="Password" type="password" sx={{mt:1}} /> 
                        
                    </Box>
                    <br/>
                    <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Save changes
                        </LoadingButton>
                    </Stack>
                </Card>

            </FormProvider>
        </Box>
    </Modal>


}
